<template>
  <div class="tags-filtros-selecionados">
    <div
      v-for="(item,index) in getDadosTagsFiltroSelecionado()"
      :key="'tag-filtro-'+index"
      class="badge badge-info px-2 mr-1 mt-1"
    >
      <div>
        <small>{{item.titulo}}</small>
      </div>
      <span>{{item.descricao}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["filtroSelecionado", "dadosFiltro"],

  data() {
    return {};
  },
  methods: {
    getDadosTagsFiltroSelecionado() {
      var tags = [];

      if (this.filtroSelecionado.termoPesquisa) {
        tags.push({
          titulo: "Marca ou Modelo",
          descricao: this.filtroSelecionado.termoPesquisa
        });
      }

      if (this.filtroSelecionado.estrelas) {
        var estrelas = this.filtroSelecionado.estrelas || [];
        for (let index = 0; index < estrelas.length; index++) {
          const estrela = estrelas[index];
          tags.push({ titulo: "Avaliação", descricao: estrela });
        }
      }

      var tagEstado = this.getTagsDoFiltro(
        "Estado",
        this.dadosFiltro.uf,
        this.filtroSelecionado.estado,
        false
      );
      tags = tags.concat(tagEstado);

      var tagsQuadro = this.getTagsDoFiltro(
        "Quadro",
        this.dadosFiltro.tipoQuadro,
        this.filtroSelecionado.quadro,
        true
      );
      tags = tags.concat(tagsQuadro);

      var tagsAro = this.getTagsDoFiltro(
        "Aro",
        this.dadosFiltro.tipoAro,
        this.filtroSelecionado.aro,
        true
      );
      tags = tags.concat(tagsAro);

      var tagsModalidade = this.getTagsDoFiltro(
        "Modalidade",
        this.dadosFiltro.tipoBike,
        this.filtroSelecionado.modalidade,
        true
      );
      tags = tags.concat(tagsModalidade);

      return tags;
    },
    getTagsDoFiltro(titulo, dados, valor, multiOpcoes) {
      if (!dados) {
        return [];
      }
      if (!valor) {
        return [];
      }

      var tags = [];

      if (multiOpcoes) {
        var valoresFiltro = valor || [];

        for (let index = 0; index < valoresFiltro.length; index++) {
          const valorFiltro = valoresFiltro[index];
          if (!valorFiltro) {
            continue;
          }

          tags.push({ titulo: titulo, descricao: dados[valorFiltro] });
        }
      } else {
        tags.push({ titulo: titulo, descricao: dados[valor] });
      }

      return tags;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/variaveis";
</style>